module.exports = __webpack_public_path__ + "static/img/img-metodologia-4.914888b1.jpg";